import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import { FeedTagEntity } from "@pages/Keyword/utils/types";
import { getPodcastKeywordCardProps } from "@pages/Section/layouts/PodcastsKeywordPage/utils/helpers";
import Card from "@particles/card/Card";
import { useListingLoadMoreStories } from "@particles/listing/hooks/useListingLoadMoreStories";

import PodcastsListingStories from "./PodcastsListingStories";

type PodcastsOverviewProps = {
  /** The list of card props to displayed */
  cardProps: ComponentProps<typeof Card>[];
  /** The entity data for the podcast keyword page */
  entity: FeedTagEntity;
};

/**
 * Component to render individual podcast listing stories.
 * Figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1476-10827&t=m7103yrVxON0jRlB-4
 */
const PodcastsOverview = ({
  cardProps = [],
  entity,
}: PodcastsOverviewProps): React.ReactElement => {
  const podcastSection = RouteFactory.podcasts.replace("/", "");
  const initialList = cardProps.slice(0, 5);

  const { ref, loadMoreData } = useListingLoadMoreStories({
    templateProps: getPodcastKeywordCardProps,
    initialList,
    sections: [podcastSection],
    urlPath: entity.tag.urlPath,
    size: 5,
  });

  return (
    <section data-testid="podcasts-overview-component">
      <div>
        {[...initialList, ...loadMoreData].map((cardProp, index) => {
          return (
            <PodcastsListingStories
              key={cardProp.id}
              cardProp={cardProp}
              index={index}
            />
          );
        })}
      </div>

      <div ref={ref} />
    </section>
  );
};

export default PodcastsOverview;
